import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Controla launches on Microsoft and Google marketplaces",
  header: "Controla launches on Microsoft and Google marketplaces",
  date: "2025-10-15",
  description:
    "Our cybersecurity tool is now available directly in Microsoft Store and Google Workspace Marketplace, making it easier than ever for SMBs to get protected.",
  category: "company",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
